import React, { useContext, useState } from 'react';
import { CompanyConnectionContext } from '../../../../../context/CompanyConnectionContext';
import { CompanyConnection, CompanyConnectionState } from '../../../../../types/companyConnection/companyConnection';
import { CompanyContext } from '../../../../../context/CompanyContext';
import PartnerCard from '../Common/PartnerCard';
import PendingCompanyConnectionModal from '../Modals/PendingCompanyConnectionModal';

export default function PartnerPendingPane() {
  const { companies } = useContext(CompanyContext);
  const { currentCompany } = useContext(CompanyContext);
  const { companyConnections } = useContext(CompanyConnectionContext);

  const [selected, setSelected] = useState<CompanyConnection | undefined>(undefined);
  const [openPendingModal, setOpenPendingModal] = useState<boolean>(false);

  const pendingConnections = Array.from(companyConnections.values()).filter(
    connection => connection.state === CompanyConnectionState.pending && connection.companyId === currentCompany.id,
  );

  return (
    <>
      {openPendingModal && selected && (
        <PendingCompanyConnectionModal connection={selected} open={openPendingModal} setOpen={setOpenPendingModal} />
      )}

      <div>
        {pendingConnections.length ? (
          <div className='grid grid-cols-1'>
            {pendingConnections.map(item => {
              const company = companies.get(item.parentId);
              if (!company) return null;

              return (
                <div>
                  <PartnerCard
                    item={item}
                    company={company}
                    onClick={() => {
                      setSelected(item);
                      setOpenPendingModal(true);
                    }}
                  />
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </>
  );
}
